"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombineProviders = void 0;
const tslib_1 = require("tslib");
const react_1 = require("react");
const CombineProviders = ({ children, providers }) => {
    let result = (0, react_1.createElement)(react_1.Fragment, undefined, children);
    for (let i = providers.length - 1; i >= 0; i--) {
        const item = providers[i];
        if (item) {
            const { provider: Provider } = item, otherProps = tslib_1.__rest(item, ["provider"]);
            result = (0, react_1.createElement)(Provider, otherProps, result);
        }
    }
    return result;
};
exports.CombineProviders = CombineProviders;
//# sourceMappingURL=index.js.map